import { Car, Check, X } from "lucide-react";

export default function CaronaCard({ value, onChange }) {
  return (
    <div
      data-testid="carona-motorista-card"
      className="rounded-3xl p-6 text-center shadow-[0_0_30px_rgba(245,179,1,0.2)]"
      style={{ background: "linear-gradient(135deg, #0A1F44 0%, #153266 100%)" }}
    >
      <span className="inline-block bg-[#F5B301] text-navy text-[10px] font-extrabold tracking-widest uppercase px-3 py-1 rounded-full mb-4">
        Seção especial
      </span>
      <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center mx-auto mb-4">
        <Car className="w-9 h-9 text-[#F5B301]" />
      </div>
      <h3 className="font-heading text-xl font-bold text-white">Carona com o motorista</h3>
      <p className="text-slate-300 text-sm mt-2 mb-6">Você deseja ir junto com o motorista?</p>

      <div className="grid grid-cols-2 gap-3">
        <button
          data-testid="carona-sim-btn"
          onClick={() => onChange(true)}
          className={`py-4 rounded-2xl font-heading font-bold text-sm flex flex-col items-center gap-1.5 active:scale-95 transition-all ${
            value === true
              ? "bg-[#F5B301] text-navy ring-4 ring-[#F5B301]/40"
              : "bg-white/10 text-white border border-white/20 hover:border-[#F5B301]/60"
          }`}
        >
          <Check className="w-6 h-6" />
          SIM, QUERO CARONA
        </button>
        <button
          data-testid="carona-nao-btn"
          onClick={() => onChange(false)}
          className={`py-4 rounded-2xl font-heading font-bold text-sm flex flex-col items-center gap-1.5 active:scale-95 transition-all ${
            value === false
              ? "bg-white text-navy ring-4 ring-white/30"
              : "bg-white/10 text-white border border-white/20 hover:border-white/50"
          }`}
        >
          <X className="w-6 h-6" />
          NÃO, NÃO QUERO
        </button>
      </div>
    </div>
  );
}
